import styled from 'styled-components';

export const NearByRoot = styled.li`
  position: relative;
  max-height: 58px;
`;
